import { Component } from 'react';
import MonacoEditor from 'react-monaco-editor';
import { T, COMMON } from '../common/js/i18n';

interface EditProps {
    value: string;
    readOnly?: boolean;
    onDone?: (value: string) => void;
    onClose?: () => void;
}

interface EditState {
    value: string;
}

export default class DataProcessorEdit extends Component<EditProps, EditState> {
    constructor(props: EditProps) {
        super(props);
        this.state = {
            value: props.value
        };
    }
    render() {
        let resizeListener: any = undefined;
        return (
            <div style={{ padding: "0.5em", boxSizing: 'border-box', height: '100%', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flex: 1, }}>
                    <MonacoEditor
                        width="100%"
                        height="100%"
                        language="lua"
                        theme="vs-dark"
                        value={this.state.value}
                        options={{
                            selectOnLineNumbers: true,
                            readOnly: this.props.readOnly
                        }}
                        onChange={(newVal: any, e: any) => {
                            this.setState({
                                value: newVal
                            });
                        }}
                        editorDidMount={(editor, monaco) => {
                            if (!resizeListener) {
                                resizeListener = () => {
                                    editor.layout();
                                };
                                window.addEventListener("resize", resizeListener);
                            }
                        }}
                        editorWillUnmount={() => {
                            if (resizeListener) {
                                window.removeEventListener("resize", resizeListener);
                                resizeListener = undefined;
                            }
                        }}
                    />
                </div>
                <div style={{ textAlign: "center", paddingTop: '0.5em' }}>
                    {
                        !this.props.readOnly && (
                            <button type="button" className="btn" onClick={() => {
                                if (this.props.onDone) {
                                    this.props.onDone(this.state.value);
                                }
                            }} style={{ marginRight: "1em" }}>{T(COMMON.OK)}</button>
                        )
                    }
                    <button type="button" className="btn" onClick={() => {
                        if (this.props.onClose) {
                            this.props.onClose();
                        }
                    }}>{T(this.props.readOnly ? COMMON.RETURN : COMMON.CANCEL)}</button>
                </div>
            </div>
        );
    }
}
